import { Box } from "@mui/material";
import { environmentBadge } from "../../utils/environment";

/** Lado do azulejo (px) que se repete pela tela. */
const TILE = 420;

/**
 * SVG usado como textura de fundo: o nome do ambiente escrito na diagonal.
 * Vira um `data:` URI para poder ser repetido via `background-repeat`, o que é
 * bem mais leve do que renderizar centenas de elementos de texto.
 */
function buildTile(text: string, color: string): string {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${TILE}" height="${TILE}" viewBox="0 0 ${TILE} ${TILE}">
        <text x="50%" y="50%" transform="rotate(-30 ${TILE / 2} ${TILE / 2})"
              text-anchor="middle" dominant-baseline="middle"
              font-family="Roboto, Helvetica, Arial, sans-serif"
              font-size="34" font-weight="700" letter-spacing="4"
              fill="${color}">${text}</text>
    </svg>`;

    return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
}

/**
 * Marca d'água do ambiente: uma camada fixa sobre toda a viewport — fica
 * "colada" na tela, não acompanha a rolagem — repetindo o nome do ambiente na
 * diagonal.
 *
 * Não intercepta cliques (`pointer-events: none`) nem entra em seleção de
 * texto, então não atrapalha o uso da aplicação. Em produção devolve `null` e
 * a tela permanece exatamente como é hoje.
 */
export default function EnvironmentWatermark() {
    if (!environmentBadge) {
        return null;
    }

    const { shortLabel, background } = environmentBadge;

    return (
        <Box
            aria-hidden
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 9998,
                pointerEvents: "none",
                userSelect: "none",
                opacity: 0.07,
                backgroundImage: buildTile(shortLabel, background),
                backgroundRepeat: "repeat",
                backgroundSize: `${TILE}px ${TILE}px`,
                // Impede que a camada crie barra de rolagem própria.
                overflow: "hidden",
            }}
        />
    );
}
